<template>
  <v-btn
    :to="{ name: 'Character', params: { id } }"
    class="mr-2 px-0"
    x-large
    min-width="52"
  >
    <v-img
      :title="this.character"
      :alt="this.character"
      class="shrink image-border-radius"
      contain
      :src="require(`@/assets/icon/Character_${characterFileName}_Thumb.png`)"
      transition="scale-transition"
      width="48"
    />
  </v-btn>
</template>

<script>
export default {
  props: {
    character: String,
    id: String
  },
  computed: {
    characterFileName () {
      return this.character.replaceAll(' ', '_')
    }
  }
}
</script>

<style>
.v-image.image-border-radius {
  border-radius: 8px;
  overflow: hidden;
}
</style>
